import { useCalls, useIncidents, usePortalClient, usePortalHub, useRealtimeConnection } from '@ngsos/portal-core/portal';

import { DevNavTabs } from '../DevNavTabs';
import { DevHubConnectionPanel } from './DevHubConnectionPanel';
import { DevHubEventLogPanel } from './DevHubEventLogPanel';
import { DevPortalStoresPanel } from './DevPortalStoresPanel';
import { useDevPortalHubLog } from './useDevPortalHubLog';
import { useVisibleTick } from './useVisibleTick';

const REFRESH_INTERVAL_MS = 1_000;

export function DevPortalHubPage() {
  const client = usePortalClient();
  const hub = usePortalHub();
  const connection = useRealtimeConnection();
  const incidents = useIncidents();
  const calls = useCalls();
  const log = useDevPortalHubLog(hub);

  useVisibleTick(REFRESH_INTERVAL_MS);

  return (
    <>
      <DevNavTabs />

      <div className="m-3 d-flex flex-column gap-4">
        <div>
          <h1 className="h4 mb-1">Portal hub</h1>
          <div className="small text-body-secondary">
            A read-only view of the portal hub connection and the stores it feeds. Nothing here changes what the portal
            does; it only reports what is already there, and only for as long as this page is open.
          </div>
        </div>

        {client === null && (
          <div className="alert alert-warning py-2 small mb-0">The portal client has not been created yet.</div>
        )}

        <DevHubConnectionPanel hub={hub} connection={connection} />

        <DevPortalStoresPanel
          incidents={incidents}
          calls={calls}
        />

        <DevHubEventLogPanel log={log} />
      </div>
    </>
  );
}
